import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Dropdown, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  TextArea,
  Input,
  Div,
  DivConteudo,
  Label,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import { isAuthAdmin } from "../../../../services/auth";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

const CardCombosEditar = (props) => {
  const id = props.match.params.id;
  const [loading, setLoading] = useState(true);
  const [nome, setNome] = useState("");
  const [imagem, setImagem] = useState("");
  const [conteudo, setConteudo] = useState("");
  const [link, setLink] = useState("");
  const [valueTotal, setValueTotal] = useState();
  const [valueCombo, setValueCombo] = useState();
  const [optionsCombos, setOptionsCombos] = useState([]);
  const [combo, setCombo] = useState();

  useEffect(() => {
    loadAuth();
    loadCombos();
    loadCardCombo();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadCardCombo = async () => {
    try {
      const res = await api.get(`/card-combo/${id}`);
      const cardcombo = res.data;
      setNome(cardcombo.nome);
      setImagem(cardcombo.image);
      setConteudo(cardcombo.content);
      setLink(cardcombo.pageLink);
      setValueTotal(cardcombo.valueTotal);
      setValueCombo(cardcombo.valueCombo);
      setCombo(cardcombo.idCombo);
      setLoading(false);
    } catch (err) {
      swal("Erro !", "Combo inexistente !", "error");
    }
  };

  const loadCombos = async () => {
    await api
      .get("/combos-nome/")
      .then((res) => {
        const newOptions = res.data.map((comb) => ({
          ...optionsCombos,
          key: comb.id_combo,
          text: comb.curso,
          value: comb.id_combo,
        }));
        setOptionsCombos(newOptions);
      })
      .catch(() => { });
  };


  const handleSubmit = async () => {

    const payload = {
      nome: nome,
      image: imagem,
      content: conteudo,
      pageLink: link,
      valueTotal: valueTotal,
      valueCombo: valueCombo,
      idCombo: combo
    };

    await api
      .put(`/card-combo/${id}`, payload)
      .then(async () => {

        let logs = { local: "combos", texto: `editou o combo de id=${id}` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        swal("Sucesso!", "Criação de combo bem sucedida", "success")

          .then(() => {
            window.location.href = "/admin/combos";
          }
          );
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Erro ao criar o combo",
          "Por favor, insira preencha todos os campos necessários",
          "error"
        );
      });
  };

  const modifyCombo = async (id) => {
    setCombo(id);

    await api.get(`/cursolist/${id}`).then((res) => {
      setValueCombo(res.data.valor);
      setImagem(`https://files.voitto.com.br/cursos/small/${res.data.url_redirect}.jpg`);
    })
    await api.get(`/combo/${id}`).then(async (res) => {
      var soma = 0;
      await Promise.all(res.data.map((comb) => (
        api.get(`/cursolist/${comb}`).then((value) => {
          soma = soma + value.data.valor;
        })
      )))
      setValueTotal(soma);
    })
  }
  
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Editar o card combo</Title>
            <Div>
              <Label>combo: </Label>
              <Dropdown
                placeholder="Selecione o combo"
                fluid
                search
                selection
                defaultValue={combo}
                options={optionsCombos}
                onChange={(e, data) => { modifyCombo(data.value) }
                }
              />
            </Div>
            <Div>
              <Label>Nome: </Label>
              <DivConteudo>
                <Input type="text" value={nome} onChange={e => setNome(e.target.value)} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Imagem: </Label>
              <DivConteudo>
                <Input type="text" value={imagem} onChange={e => setImagem(e.target.value)} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Conteudo: </Label>
              <DivConteudo>
                <TextArea rows="5" value={conteudo} onChange={e => setConteudo(e.target.value)} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Link da página do pacote: </Label>
              <DivConteudo>
                <Input type="text" placeholder="/pacotes/" value={link} onChange={e => setLink(e.target.value)} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Valor total: </Label>
              <DivConteudo>
                <Input type="number" value={valueTotal} onChange={e => setValueTotal(e.target.value)} />
              </DivConteudo>
            </Div>
            <Div>
              <Label>Valor do Combo: </Label>
              <DivConteudo>
                <Input type="number" value={valueCombo} onChange={e => setValueCombo(e.target.value)} />
              </DivConteudo>
            </Div>
            <Button onClick={handleSubmit}>
              <Icon name="save" />
              Salvar
            </Button>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(CardCombosEditar);
